import { Injectable } from '@angular/core';
import 'firebase/messaging';
import { TranslateService } from '@ngx-translate/core';
import { DriverStateEnum } from '../../enum/driverState.enum';
import { catchError, map, Observable, Subject, throwError } from 'rxjs';
import { TravelFilterCache } from '../../models/cache/travel-filter.cache';
import { ConnectionServices } from '../../authentication/connection/connection.service';
import { IdentityService } from '../../authentication/identity.service';
import { NavigationService } from '../../utilities/navigation.service';
import { GridRequestDto, IParkingRequestDTO, IParkingResponseDTO, ITollRequestDTO, ITollResponseDTO, PassengerSignatureResponseDTO, QuoteResponseDTO, SaveTravel, SimulateTravelRequestDTO, TravelAuditResponseDTO, TravelGrid, TravelsGridResponseDTO, TravelSimulateAllResponseDto, TravelSimulateResponseDto } from '../../authentication/connection/interfaces/apiInterfaces';
import { AlertService } from '../../components/alerts/alert.service';
import { IMagiisGeoCodeServiceCommandParameters, MagiisGeoCodeServiceCommand } from '../../admin/command/magiisGeoCodeService.command';
import { GetMagiisAutocompleteCommand, IMagiisGetAutocompleteRequest, IMagiisGetAutocompleteResponse } from '../../admin/command/getMagiisAutocomplete.command';
import { CheckingAccountLimitType } from '../../enum/checkingAccountLimitType.enum';
import { CheckingAccountLimitCommand, IICheckingAccountLimitParameters } from '../../travel/command/checkingAccountLimit.command';
import { SimulateAllTravelCommand } from '../../travel/command/simulateAllTravel.command';
import { ISimulateTravelCommandParameters } from '../../travel/command/simulateTravel.command';
import { CheckPlaceCommand, ICheckPlaceParameters, ICheckPlaceResponse } from './checkPlace.command';


@Injectable()
export class TravelService {
  private quoteIdCreated: number;
  private travelIdCreated: number;
  private driverConfirmation: Subject<boolean> = new Subject<boolean>();
  private _travelFilterCache: TravelFilterCache = new TravelFilterCache();
  private _hasTravelFilter = false;

  constructor(
    private _connectionService: ConnectionServices,
    private _translateService: TranslateService,
    private _identityService: IdentityService,
    private _navigationService: NavigationService,
    private _alertService: AlertService
  ) { }

  // public getTravelIdCreated(): number {
  //   return this.travelIdCreated;
  // }

  // private setTravelCreatedId(travelId: number) {
  //   this.travelIdCreated = travelId;
  // }

  // private setQuoteCreatedId(quoteId: number) {
  //   this.quoteIdCreated = quoteId;
  // }

  // public clearLastTravelCreated() {
  //   this.travelIdCreated = null;
  // }

  // public hasTravelFilter(): boolean {
  //   return this._hasTravelFilter;
  // }

  // public getTravelFilterCache(): TravelFilterCache {
  //   return this._travelFilterCache;
  // }

  // public setTravelFilterCache(filter: TravelFilterCache): void {
  //   this._travelFilterCache = filter;
  //   this._hasTravelFilter = true;
  // }

  // public clearTravelFilterCache(): void {
  //   this._travelFilterCache = new TravelFilterCache();
  //   this._hasTravelFilter = false;
  // }

  // public driverConfirmed(isConfirmed: boolean, travelId: number) {
  //   this._modalService.alertSuccess(
  //     this._translateService.instant('toast.info.title'),
  //     this._translateService
  //       .instant('toast.driver.message.confirm')
  //       .replace('{travelId}', travelId)
  //   ).then((x) => {
  //   });
  // }

  // public remindNewProgrammedTrips(travelId: number) {
  //   this._modalService.alertWarning(
  //     this._translateService.instant('toast.info.title'),
  //     this._translateService
  //       .instant('toast.info.message.assign_required')
  //       .replace('{travelId}', travelId)
  //   ).then((x) => {
  //   });
  // }

  // public lostProgrammedTrip(travelId: number) {
  //   this._modalService.alertWarning(
  //     this._translateService.instant('toast.info.title'),
  //     this._translateService
  //       .instant('toast.info.message.lost_programmed_trip')
  //       .replace('{travelId}', travelId)
  //   ).then((x) => {
  //   });
  // }

  // public getDriverConfirmation(): Subject<boolean> {
  //   return this.driverConfirmation;
  // }

  // public getTravels(getTravelDto: GridRequestDto, driverId: number, state: string, platform: boolean, isProgrammed?: boolean, find?: string, dateFrom?: Date, dateTo?: Date, isPaxVip?: boolean): Observable<TravelGrid> {
  //   const driverCommand = new GetTravelsCommand();
  //   driverCommand.setParameters(<IGetTravelsCommandParameters>{
  //     carrierUserId: getTravelDto.carrierUserId,
  //     column: getTravelDto.column,
  //     page: getTravelDto.page,
  //     size: getTravelDto.size,
  //     sort: getTravelDto.sort,
  //     driverId: driverId,
  //     state: state,
  //     platform: platform,
  //     find: find,
  //     travelDateFrom: dateFrom,
  //     travelDateTo: dateTo,
  //     programmed: isProgrammed,
  //     isPaxVip
  //   });
  //   return this._connectionService
  //     .Request(driverCommand)
  //     .pipe(
  //       map(data => {
  //           return data as TravelGrid;
  //       }),
  //       catchError(() => {
  //           return throwError(() => false);
  //       })
  //   );
  // }

  // public getContractorTravels(
  //   getTravelDto: GridRequestDto,
  //   driverId: number,
  //   state: string,
  //   platform: boolean,
  //   isProgrammed?: boolean,
  //   find?: string,
  //   dateFrom?: Date,
  //   dateTo?: Date
  // ): Observable<TravelGrid> {
  //   const driverCommand = new GetContractorTravelsCommand();
  //   driverCommand.setParameters(<IGetContractorTravelsCommandParameters>{
  //     contractorId: this._identityService.userId,
  //     carrierUserId: '0',
  //     column: getTravelDto.column,
  //     page: getTravelDto.page,
  //     size: getTravelDto.size,
  //     sort: getTravelDto.sort,
  //     driverId: driverId,
  //     state: state,
  //     platform: platform,
  //     find: find,
  //     travelDateFrom: dateFrom,
  //     travelDateTo: dateTo,
  //     programmed: isProgrammed,
  //   });
  //   return this._connectionService
  //     .Request(driverCommand)
  //     .pipe(
  //       map(data => {
  //           return data as TravelGrid;
  //       }),
  //       catchError(() => {
  //         // this._notificationsService.showHttpErrorMessage(
  //       //   'toast.travels.title',
  //       //   error
  //       // );
  //           return throwError(() => false);
  //       })
  //     )
  // }

  // public createTravel(
  //   travelDTO: SimulateTravelRequestDTO,
  //   exceedingLimitAllow: boolean,
  //   options?: {
  //     createdBy?: string;
  //     isSpecialAssign?: boolean;
  //   }
  // ): Observable<TravelsGridResponseDTO> {
  //   let travelCommand = new AddTravelCommand();
  //   let parameters: any = {
  //     affiAgreementId: travelDTO.affiAgreementId,
  //     carrierUserId: travelDTO.carrierUserId,
  //     destination: travelDTO.destination,
  //     firstName: travelDTO.firstName,
  //     lastName: travelDTO.lastName,
  //     mail: travelDTO.mail,
  //     note: travelDTO.note,
  //     origin: travelDTO.origin,
  //     passengerUserId: travelDTO.passengerUserId,
  //     paymentMethod: travelDTO.paymentMethod,
  //     phoneNumber: travelDTO.phoneNumber,
  //     platform: travelDTO.platform,
  //     travelPreferences: travelDTO.travelPreferences,
  //     originToken: this._identityService.firebaseToken,
  //     isDelivery: travelDTO.isDelivery,
  //     isRental: travelDTO.isRental,
  //     rentalType: travelDTO.rentalType,
  //     rentalHours: travelDTO.rentalHours,
  //     requesterUserId: travelDTO.requesterUserId,
  //     isProgrammed: travelDTO.isProgrammed,
  //     dateProgrammed: travelDTO.dateProgrammed,
  //     driverProgrammedId: travelDTO.driverProgrammedId,
  //     recurringValue: travelDTO.recurringValue,
  //     recurringEnd: travelDTO.recurringEnd,
  //     hasGuestPassenger: travelDTO.hasGuestPassenger,
  //     guestPassengerName: travelDTO.guestPassengerName,
  //     contractorEmployeeId: travelDTO.contractorEmployeeId,
  //     waypoints: travelDTO.waypoints,
  //     roundTrip: travelDTO.roundtrip,
  //     serviceType: travelDTO.serviceType,
  //     avoidHighways: travelDTO.avoidHighways || false,
  //     avoidTolls: travelDTO.avoidTolls || false,
  //     fastestRoute: travelDTO.fastestRoute || false,
  //     recurringPattern: travelDTO.recurringPattern,
  //     selectedDaysOfWeek: travelDTO.selectedDaysOfWeek,
  //     cardDetail: travelDTO.cardDetail,
  //     airlineName: travelDTO.airlineName,
  //     departArrival: travelDTO.departArrival,
  //     arrivalCheck: travelDTO.arrivalCheck,
  //     departureCheck: travelDTO.departureCheck,
  //     flightNumber: travelDTO.flightNumber,
  //     departReturnSchedule: travelDTO.departReturnSchedule,
  //     operatorUserId: travelDTO.operatorUserId,
  //     pbxCaller: travelDTO.pbxCaller,
  //     tipPercentage: travelDTO.tipPercentage,
  //     tipAmount: travelDTO.tipAmount,
  //     driverInstructions: travelDTO.driverInstructions,
  //     fixedCost: travelDTO.fixedCost,
  //     multiTripSeq: travelDTO.multiTripSeq,
  //     pickupGmt: travelDTO.pickupGmt,
  //     otherCosts: travelDTO.otherCosts,
  //     fixConceptList: travelDTO.fixConceptList,
  //     calculateTaxes: travelDTO.calculateTaxes,
  //     fixConceptsCost: travelDTO.fixConceptsCost,
  //     taxesCost: travelDTO.taxesCost,
  //     qrPayment: travelDTO.qrPayment
  //   };
  //   if (
  //     options &&
  //     options.createdBy != null &&
  //     options.createdBy != undefined
  //   ) {
  //     parameters.createdBy = options.createdBy;
  //   }
  //   if (
  //     options &&
  //     options.isSpecialAssign != null &&
  //     options.isSpecialAssign != undefined
  //   ) {
  //     parameters.isSpecialAssign = options.isSpecialAssign;
  //   }

  //   travelCommand.setParameters(<IAddTravelCommandParameters>parameters);
  //   return this._connectionService
  //     .Request(travelCommand)
  //     .pipe(
  //       map(response => {
  //         if (!response.autodispatch) {
  //           this.setTravelCreatedId(response.travelId);
  //           // this._notificationsService.showSuccessMessage(
  //           //   'toast.travels.title',
  //           //   'toast.travels.message.successful_message_add'
  //           // );
  //         }
  //       }),
  //       catchError(() => {
  //         // if (error.status === 404) {
  //       //   if (
  //       //     error.error.errorCode !== undefined &&
  //       //     error.error.errorCode !== null &&
  //       //     error.error.errorCode !== 'undefined'
  //       //   ) {
  //       //     if (error.error.errorCode === 'ACTION_NOT_ALLOWED') {
  //       //       this._notificationsService.showInternalErrorMessage(
  //       //         'toast.travels.title',
  //       //         'toast.travels.error_code.trips_action_not_allowed'
  //       //       );
  //       //     }
  //       //     if (error.error.errorCode === 'DRIVERS_NOT_AVAILABLE') {
  //       //       this._notificationsService.showInternalErrorMessage(
  //       //         'toast.travels.title',
  //       //         'toast.travels.error_code.drivers_not_available'
  //       //       );
  //       //       if (error.error.errorCode === 'TRAVEL_INVALID') {
  //       //         this._notificationsService.showInternalErrorMessage(
  //       //           'toast.travels.title',
  //       //           'toast.travels.error_code.travel_invalid'
  //       //         );
  //       //       }
  //       //       this._navigationService.navigate(RouterEnum.travelGrid);
  //       //     }
  //       //   }
  //       // } else if (error.status === 409) {
  //       //   if (error.error.errorCode === 'TRANSPORT_TYPE_NOT_FOUND') {
  //       //     this._notificationsService.showInternalErrorMessage(
  //       //       'toast.travels.title',
  //       //       'toast.travels.error_code.vehicle_type_unavailable'
  //       //     );
  //       //   }
  //       // } else if (error.status === 406) {
  //       //   if (
  //       //     error.error.errorCode !== undefined ||
  //       //     error.error.errorCode !== null
  //       //   ) {
  //       //     if (error.error.errorCode === 'PASSENGER_ALREADY_TRAVELING') {
  //       //       this._notificationsService.showInternalErrorMessage(
  //       //         'toast.travels.title',
  //       //         'toast.travels.error_code.passenger_already_travelling'
  //       //       );
  //       //     }
  //       //     if (error.error.errorCode === 'AFFILIATE_CC_WARRANTY_EXPIRED') {
  //       //       this._notificationsService.showInternalErrorMessage(
  //       //         'toast.travels.title',
  //       //         'toast.travels.error_code.affiliate_cc_warranty_expired'
  //       //       );
  //       //     }
  //       //   }
  //       // } else if (error.status === 400) {
  //       //   if (
  //       //     error.error.errorCode !== undefined ||
  //       //     error.error.errorCode !== null
  //       //   ) {
  //       //     if (error.error.errorCode === 'INVALID_RECURRING_START') {
  //       //       this._notificationsService.showInternalErrorMessage(
  //       //         'toast.travels.title',
  //       //         'toast.travels.error_code.travel_invalid'
  //       //       );
  //       //     }
  //       //     if (error.error.errorCode === 'INVALID_RECURRING_END') {
  //       //       this._notificationsService.showInternalErrorMessage(
  //       //         'toast.travels.title',
  //       //         'toast.travels.error_code.invalid_recurring_end'
  //       //       );
  //       //     }
  //       //     if (error.error.errorCode === 'CONTRACTOR_AREA_INACTIVE') {
  //       //       this._notificationsService.showInternalErrorMessage(
  //       //         'toast.travels.title',
  //       //         'toast.contractor.error_code.contractor_area_inactive'
  //       //       );
  //       //     }
  //       //     if (error.error.errorCode === 'CONTRACTOR_EMPLOYEE_INACTIVE') {
  //       //       this._notificationsService.showInternalErrorMessage(
  //       //         'toast.travels.title',
  //       //         'toast.contractor.error_code.contractor_employee_inactive'
  //       //       );
  //       //     }
  //       //     if (error.error.errorCode === 'LIMIT_EXCEEDED') {
  //       //       return Observable.throw(error);
  //       //     }
  //       //     if (error.error.errorCode === 'INVALID_CARD') {
  //       //       this._notificationsService.showInternalErrorMessage(
  //       //         'toast.travels.title',
  //       //         'toast.travels.error_code.invalid_card'
  //       //       );
  //       //     }
  //       //     if (error.error.errorCode === 'INVALID_DATE_PROGRAMMED') {
  //       //       this._notificationsService.showInternalErrorMessage(
  //       //         'toast.travels.title',
  //       //         'toast.travels.error_code.invalid_date_programmed'
  //       //       )
  //       //     }
  //       //   } else {
  //       //     this._notificationsService.showHttpErrorMessage(
  //       //       'toast.travels.title',
  //       //       error
  //       //     );
  //       //   }
  //       // } else {
  //       //   this._notificationsService.showHttpErrorMessage(
  //       //     'toast.travels.title',
  //       //     error
  //       //   );
  //       // }
  //           return throwError(() => false);
  //       })
  //     )
  // }

  // public saveTravel(
  //   saveTravelOject: SaveTravel
  // ): Observable<QuoteResponseDTO> {
  //   let travelCommand = new SaveTravelCommand();
  //   let parameters: any = {
  //     carrierUserId: saveTravelOject.carrierUserId,
  //     passengerUserId: saveTravelOject.passengerUserId,
  //     destination: saveTravelOject.destination,
  //     firstName: saveTravelOject.firstName,
  //     lastName: saveTravelOject.lastName,
  //     mail: saveTravelOject.mail,
  //     note: saveTravelOject.note,
  //     origin: saveTravelOject.origin,
  //     paymentMethod: saveTravelOject.paymentMethod,
  //     phoneNumber: saveTravelOject.phoneNumber,
  //     isRental: saveTravelOject.isRental,
  //     rentalType: saveTravelOject.rentalType,
  //     rentalHours: saveTravelOject.rentalHours,
  //     dateProgrammed: saveTravelOject.dateProgrammed,
  //     hasGuestPassenger: saveTravelOject.hasGuestPassenger,
  //     guestPassengerName: saveTravelOject.guestPassengerName,
  //     roundTrip: saveTravelOject.roundTrip,
  //     cardDetail: saveTravelOject.cardDetail,
  //     pickupGmt: saveTravelOject.pickupGmt,
  //     language: saveTravelOject.language,
  //     vehicleTypeId: saveTravelOject.vehicleTypeId
  //   };

  //   travelCommand.setParameters(<ISaveTravelCommandParameters>parameters);
  //   return this._connectionService
  //     .Request(travelCommand)

  //     .map((response) => {
  //       this.setQuoteCreatedId(response.quoteId);
  //       this._notificationsService.showSuccessMessage(
  //         'toast.travels.title',
  //         'toast.travels.message.successful_message_quote_add'
  //       );
  //       return response;
  //     })
  //     .catch((error) => {
  //       if (error.status === 404) {
  //         if (
  //           error.error.errorCode !== undefined &&
  //           error.error.errorCode !== null &&
  //           error.error.errorCode !== 'undefined'
  //         ) {
  //           if (error.error.errorCode === 'ACTION_NOT_ALLOWED') {
  //             this._notificationsService.showInternalErrorMessage(
  //               'toast.travels.title',
  //               'toast.travels.error_code.trips_action_not_allowed'
  //             );
  //           }
  //           if (error.error.errorCode === 'DRIVERS_NOT_AVAILABLE') {
  //             this._notificationsService.showInternalErrorMessage(
  //               'toast.travels.title',
  //               'toast.travels.error_code.drivers_not_available'
  //             );
  //             if (error.error.errorCode === 'TRAVEL_INVALID') {
  //               this._notificationsService.showInternalErrorMessage(
  //                 'toast.travels.title',
  //                 'toast.travels.error_code.travel_invalid'
  //               );
  //             }
  //             this._navigationService.navigate(RouterEnum.travelGrid);
  //           }
  //         }
  //       } else if (error.status === 409) {
  //         if (error.error.errorCode === 'TRANSPORT_TYPE_NOT_FOUND') {
  //           this._notificationsService.showInternalErrorMessage(
  //             'toast.travels.title',
  //             'toast.travels.error_code.vehicle_type_unavailable'
  //           );
  //         }
  //       } else if (error.status === 406) {
  //         if (
  //           error.error.errorCode !== undefined ||
  //           error.error.errorCode !== null
  //         ) {
  //           if (error.error.errorCode === 'PASSENGER_ALREADY_TRAVELING') {
  //             this._notificationsService.showInternalErrorMessage(
  //               'toast.travels.title',
  //               'toast.travels.error_code.passenger_already_travelling'
  //             );
  //           }
  //           if (error.error.errorCode === 'AFFILIATE_CC_WARRANTY_EXPIRED') {
  //             this._notificationsService.showInternalErrorMessage(
  //               'toast.travels.title',
  //               'toast.travels.error_code.affiliate_cc_warranty_expired'
  //             );
  //           }
  //         }
  //       } else if (error.status === 400) {
  //         if (
  //           error.error.errorCode !== undefined ||
  //           error.error.errorCode !== null
  //         ) {
  //           if (error.error.errorCode === 'INVALID_RECURRING_START') {
  //             this._notificationsService.showInternalErrorMessage(
  //               'toast.travels.title',
  //               'toast.travels.error_code.travel_invalid'
  //             );
  //           }
  //           if (error.error.errorCode === 'INVALID_RECURRING_END') {
  //             this._notificationsService.showInternalErrorMessage(
  //               'toast.travels.title',
  //               'toast.travels.error_code.invalid_recurring_end'
  //             );
  //           }
  //           if (error.error.errorCode === 'CONTRACTOR_AREA_INACTIVE') {
  //             this._notificationsService.showInternalErrorMessage(
  //               'toast.travels.title',
  //               'toast.contractor.error_code.contractor_area_inactive'
  //             );
  //           }
  //           if (error.error.errorCode === 'CONTRACTOR_EMPLOYEE_INACTIVE') {
  //             this._notificationsService.showInternalErrorMessage(
  //               'toast.travels.title',
  //               'toast.contractor.error_code.contractor_employee_inactive'
  //             );
  //           }
  //           if (error.error.errorCode === 'LIMIT_EXCEEDED') {
  //             return Observable.throw(error);
  //           }
  //           if (error.error.errorCode === 'INVALID_CARD') {
  //             this._notificationsService.showInternalErrorMessage(
  //               'toast.travels.title',
  //               'toast.travels.error_code.invalid_card'
  //             );
  //           }
  //           if (error.error.errorCode === 'INVALID_DATE_PROGRAMMED') {
  //             this._notificationsService.showInternalErrorMessage(
  //               'toast.travels.title',
  //               'toast.travels.error_code.invalid_date_programmed'
  //             )
  //           }
  //         } else {
  //           this._notificationsService.showHttpErrorMessage(
  //             'toast.travels.title',
  //             error
  //           );
  //         }
  //       } else {
  //         this._notificationsService.showHttpErrorMessage(
  //           'toast.travels.title',
  //           error
  //         );
  //       }
  //       return Observable.throw(false);
  //     });
  // }

  // public simulate(
  //   travelDTO: SimulateTravelRequestDTO
  // ): Observable<TravelSimulateResponseDto> {
  //   let command = new SimulateTravelCommand();
  //   command.setParameters(<ISimulateTravelCommandParameters>{
  //     affiAgreementId: travelDTO.affiAgreementId,
  //     destination: travelDTO.destination,
  //     origin: travelDTO.origin,
  //     firstName: travelDTO.firstName,
  //     lastName: travelDTO.lastName,
  //     mail: travelDTO.mail,
  //     note: travelDTO.note,
  //     passengerUserId: travelDTO.passengerUserId,
  //     phoneNumber: travelDTO.phoneNumber,
  //     platform: travelDTO.platform,
  //     travelPreferences: travelDTO.travelPreferences,
  //     paymentMethod: travelDTO.paymentMethod,
  //     carrierUserId: travelDTO.carrierUserId,
  //     isDelivery: travelDTO.isDelivery,
  //     isRental: travelDTO.isRental,
  //     rentalType: travelDTO.rentalType,
  //     rentalHours: travelDTO.rentalHours,
  //     requesterUserId: travelDTO.requesterUserId,
  //     isProgrammed: travelDTO.isProgrammed,
  //     dateProgrammed: travelDTO.dateProgrammed,
  //     driverProgrammedId: travelDTO.driverProgrammedId,
  //     waypoints: travelDTO.waypoints,
  //     roundTrip: travelDTO.roundtrip,
  //     serviceType: travelDTO.serviceType,
  //     avoidTolls: travelDTO.avoidTolls || false,
  //     avoidHighways: travelDTO.avoidHighways || false,
  //     fastestRoute: travelDTO.fastestRoute || false,
  //     contractorEmployeeId: travelDTO.contractorEmployeeId,
  //     operatorUserId: travelDTO.operatorUserId,
  //     pbxCaller: travelDTO.pbxCaller,
  //     tipPercentage: travelDTO.tipPercentage,
  //     tipAmount: travelDTO.tipAmount,
  //     otherCosts: travelDTO.otherCosts
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .pipe(
  //       map(data => {
  //         return data as TravelSimulateResponseDto;
  //       }),
  //       catchError((error: any) => {
  //         return throwError(() => error);
  //     }));
  // }

  public checkExceedingLimit(
    carrierUserId: string,
    requesterUserId: string,
    paymentMethod: String
  ): Observable<CheckingAccountLimitType> {
    let command = new CheckingAccountLimitCommand();
    command.setParameters(<IICheckingAccountLimitParameters>{
      carrierUserId: carrierUserId,
      requesterUserId: requesterUserId,
      paymentMethod: paymentMethod,
    });

    return this._connectionService
      .Request(command)
      .pipe(
        map(data => {
          return data as CheckingAccountLimitType;
        }),
        catchError(() => {
          // this._notificationsService.showHttpErrorMessage(
          //   'toast.shared.error_code.0',
          //   error
          // );
          return throwError(() => false);
        }));
  }

  // public getBudget(
  //   TravelBudGetDTO: TravelBudGetRequestDTO
  // ): Observable<IPayBudGetRequestDTO> {
  //   let command = new TravelBudGetCommand();
  //   command.setCarrierId(TravelBudGetDTO.carrierUserId);
  //   command.addCommandBody(<ITravelBudGetCommandParameters>{
  //     destination: TravelBudGetDTO.destination,
  //     origin: TravelBudGetDTO.origin,
  //     paymentMethod: TravelBudGetDTO.paymentMethod,
  //     carrierUserId: TravelBudGetDTO.carrierUserId,
  //     vehicleTypeId: TravelBudGetDTO.vehicleTypeId,
  //     dayTime: TravelBudGetDTO.dayTime,
  //     waitTime: TravelBudGetDTO.waitTime,
  //     additionalStop: TravelBudGetDTO.additionalStop,
  //     parking: TravelBudGetDTO.parking,
  //     toll: TravelBudGetDTO.toll,
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       return response as IPayBudGetRequestDTO;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.travels.title',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // public getTravelsSurrender(
  //   travelSurrender: TravelSurrenderRequestDTO
  // ): Observable<IGetTravelsSurrenderResponse> {
  //   let command = new GetTravelsSurrenderCommand();
  //   travelSurrender.carrierId = this._identityService.userId;
  //   command.setParameters(travelSurrender);
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       return response as IGetTravelsSurrenderResponse;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.travels.title',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // getTravelToll(
  //   carrierId: number,
  //   travelId: number,
  //   tollId: number
  // ): Observable<ITollResponseDTO> {
  //   const tollCommand = new GetTravelTollCommand();
  //   tollCommand.setParameters(<ITollRequestDTO>{
  //     carrierId,
  //     travelId,
  //     tollId,
  //   });

  //   return this._connectionService
  //     .Request(tollCommand)
  //     .pipe(
  //       map((res) => res as ITollResponseDTO),
  //       catchError(() => {
  //         return throwError(() => false);
  //     }));
  // }

  // getTravelParking(
  //   carrierId: number,
  //   travelId: number,
  //   parkingId: number
  // ): Observable<IParkingResponseDTO> {
  //   const parkingCommand = new GetTravelParkingCommand();
  //   parkingCommand.setParameters(<IParkingRequestDTO>{
  //     carrierId,
  //     travelId,
  //     parkingId,
  //   });

  //   return this._connectionService
  //     .Request(parkingCommand)
  //     .pipe(
  //       map((res) => res as IParkingResponseDTO),
  //       catchError(() => {
  //         return throwError(() => false);
  //     }));
  // }

  // updateTravelToll(
  //   carrierId: number,
  //   travelId: number,
  //   tollUpdated: ITollResponseDTO
  // ): Observable<ITollResponseDTO> {
  //   const tollCommand = new PutTravelTollCommand();
  //   tollCommand.setUrlParameters(<ITollRequestDTO>{
  //     carrierId,
  //     travelId,
  //     tollId: tollUpdated.id,
  //   });
  //   tollCommand.addCommandBody(tollUpdated);

  //   return this._connectionService
  //     .Request(tollCommand)
  //     .map((res) => res as ITollResponseDTO)
  //     .catch((error) => Observable.throw(error));
  // }
  // updateTravelParking(
  //   carrierId: number,
  //   travelId: number,
  //   parkingUpdated: IParkingResponseDTO
  // ): Observable<IParkingResponseDTO> {
  //   const parkingCommand = new PutTravelParkingCommand();
  //   parkingCommand.setUrlParameters(<IParkingRequestDTO>{
  //     carrierId,
  //     travelId,
  //     parkingId: parkingUpdated.id,
  //   });
  //   parkingCommand.addCommandBody(parkingUpdated);

  //   return this._connectionService
  //     .Request(parkingCommand)
  //     .map((res) => res as IParkingResponseDTO)
  //     .catch((error) => Observable.throw(error));
  // }

  // public getCandidate(
  //   carrierUserId: string,
  //   travelId: string,
  //   direction: DirectionEnum,
  //   showError: boolean = true
  // ): Observable<IGetCandidateResponse> {
  //   let command = new GetCandidateCommand();
  //   command.setParameters(<IGetCandidateCommandParameters>{
  //     carrierUserId: carrierUserId,
  //     travelId: travelId,
  //     direction: direction,
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       if (error.error.errorCode === ErrorsEnum.TRAVEL_WITHOUT_CANDIDATES) {
  //         this._notificationsService.showInternalErrorMessage(
  //           'toast.travels.title',
  //           'travel_without_candidates'
  //         );
  //       } else {
  //         this._notificationsService.showHttpErrorMessage(
  //           'toast.travels.title',
  //           error
  //         );
  //       }
  //       return Observable.throw(false);
  //     });
  // }

  // public getDriversFleet(
  //   carrierUserId: string,
  //   travelId: number,
  //   page: number,
  //   size: number,
  //   column: string,
  //   sort?: SortEnum,
  //   date?: Date,
  //   state?: DriverStateEnum
  // ): Observable<IGetDriversFleetResponse> {
  //   let command = new GetDriversFleetCommand();
  //   command.setParameters(<IGetDriversFleetCommandParameters>{
  //     carrierUserId: carrierUserId,
  //     travelId: travelId,
  //     column: column,
  //     page: page,
  //     size: size,
  //     sort: sort,
  //     date: date,
  //     state: state,
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       if (
  //         error.error.errorCode !== undefined &&
  //         error.error.errorCode !== null &&
  //         error.error.errorCode !== 'undefined'
  //       ) {
  //         if (error.error.errorCode === 'ACTION_NOT_ALLOWED') {
  //           this._notificationsService.showInternalErrorMessage(
  //             'toast.travels.title',
  //             'toast.travels.error_code.trips_action_not_allowed'
  //           );
  //         }
  //         if (error.error.errorCode === 'DRIVERS_NOT_AVAILABLE') {
  //           this._notificationsService.showInternalErrorMessage(
  //             'toast.travels.title',
  //             'toast.travels.error_code.drivers_not_available'
  //           );
  //         }
  //       } else if (
  //         error.error.errorCode === ErrorsEnum.TRAVEL_WITHOUT_CANDIDATES
  //       ) {
  //         this._notificationsService.showInternalErrorMessage(
  //           'toast.travels.title',
  //           'toast.travels.error_code.travel_without_candidates'
  //         );
  //       } else {
  //         this._notificationsService.showHttpErrorMessage(
  //           'toast.travels.title',
  //           error
  //         );
  //       }
  //       return Observable.throw(false);
  //     });
  // }

  // public getCandidatesForTravel(
  //   carrierUserId: string,
  //   travelId: string,
  //   page: number,
  //   size: number,
  //   column?,
  //   sort?
  // ): Observable<any> {
  //   let command = new GetCandidateForTravelCommand();
  //   command.setParameters(<IGetCandidateForTravelCommandParameters>{
  //     carrierUserId: carrierUserId,
  //     travelId: travelId,
  //     column: sort,
  //     page: page,
  //     size: size,
  //     sort: column,
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       if (
  //         error.error.errorCode !== undefined &&
  //         error.error.errorCode !== null &&
  //         error.error.errorCode !== 'undefined'
  //       ) {
  //         if (error.error.errorCode === 'ACTION_NOT_ALLOWED') {
  //           this._notificationsService.showInternalErrorMessage(
  //             'toast.travels.title',
  //             'toast.travels.error_code.trips_action_not_allowed'
  //           );
  //         }
  //         if (error.error.errorCode === 'DRIVERS_NOT_AVAILABLE') {
  //           this._notificationsService.showInternalErrorMessage(
  //             'toast.travels.title',
  //             'toast.travels.error_code.drivers_not_available'
  //           );
  //         }
  //         if (error.error.errorCode === 'CONTRACTOR_AREA_INACTIVE') {
  //           this._notificationsService.showInternalErrorMessage(
  //             'toast.travels.title',
  //             'toast.contractors.error_code.contractor_area_inactive'
  //           );
  //         }
  //         if (error.error.errorCode === 'CONTRACTOR_EMPLOYEE_INACTIVE') {
  //           this._notificationsService.showInternalErrorMessage(
  //             'toast.travels.title',
  //             'toast.travels.error_code.contractor_employee_inactive'
  //           );
  //         }
  //       } else if (
  //         error.error.errorCode === ErrorsEnum.TRAVEL_WITHOUT_CANDIDATES
  //       ) {
  //         this._notificationsService.showInternalErrorMessage(
  //           'toast.travels.title',
  //           'toast.travels.error_code.travel_without_candidates'
  //         );
  //       } else {
  //         this._notificationsService.showHttpErrorMessage(
  //           'toast.travels.title',
  //           error
  //         );
  //       }
  //       return Observable.throw(false);
  //     });
  // }

  // public rejectDriverCandidate(
  //   carrierUserId: string,
  //   travelId: string,
  //   driverId: string
  // ): Observable<IGetCandidateResponse> {
  //   let command = new RejectDriverCandidateCommand();
  //   command.setParameters(<IRejectDriverCandidateCommandParameters>{
  //     carrierUserId: carrierUserId,
  //     travelId: travelId,
  //     driverId: driverId,
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.travels.title',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // public assignCandidate(
  //   travelId: number,
  //   driverUserId: number,
  //   carrierUserId: number
  // ) {
  //   let command = new AssignCandidateCommand();
  //   command.setParameters(<IAssignCandidateParameters>{
  //     carrierUserId: carrierUserId,
  //     driverUserId: driverUserId,
  //     travelId: travelId,
  //     userId: this._identityService.subUserId,
  //   });
  //   return (
  //     this._connectionService
  //       .Request(command)
  //       /*.pipe(tap(() => {
  //       throw Observable.throw({errorCode: ErrorsEnum.TRAVEL_ALREADY_CANCELLED});
  //     }))*/
  //       .map((data) => {
  //         this._notificationsService.showSuccessMessage(
  //           'toast.shared.assign_succesful',
  //           'toast.driver.message.assign_successful'
  //         );
  //       })
  //       .catch((error) => {
  //         if (
  //           error.error.errorCode === ErrorsEnum.DRIVER_NOT_ACCEPT_PAYMENT_METHOD
  //         ) {
  //           this._notificationsService.showInternalErrorMessage(
  //             'toast.shared.assign_error',
  //             'toast.driver.error_code.driver_not_accept_payment_method'
  //           );
  //         } else if (
  //           error.error.errorCode === ErrorsEnum.DRIVER_IS_NOT_AVAILABLE
  //         ) {
  //           this._notificationsService.showInternalErrorMessage(
  //             'toast.shared.assign_error',
  //             'toast.driver.error_code.is_not_available'
  //           );
  //         } else if (
  //           error.error.errorCode === ErrorsEnum.DRIVER_WITHOUT_VEHICLE
  //         ) {
  //           this._notificationsService.showInternalErrorMessage(
  //             'toast.shared.assign_error',
  //             'toast.driver.error_code.without_vehicle'
  //           );
  //         } else if (
  //           error.error.errorCode === ErrorsEnum.VEHICLE_OWNER_NOT_FOUND
  //         ) {
  //           this._notificationsService.showInternalErrorMessage(
  //             'toast.shared.assign_error',
  //             'toast.vehicle.error_code.owner_not_found'
  //           );
  //         } else if (
  //           error.error.errorCode === ErrorsEnum.TRAVEL_INVALID_STATE
  //         ) {
  //           this._notificationsService.showInternalErrorMessage(
  //             'toast.shared.assign_error',
  //             'toast.travels.error_code.travel_invalid_state'
  //           );
  //         } else {
  //           this._notificationsService.showHttpErrorMessage(
  //             'toast.shared.assign_error',
  //             error
  //           );
  //         }
  //         return Observable.throw(error);
  //       })
  //   );
  // }

  // public cancelTravel(
  //   travelId: number,
  //   motive: string,
  //   canceledBy: string,
  //   carrierUserId: string,
  //   checkPassengerCancelation: boolean
  // ): Observable<ICancelTravelResponse> {
  //   let command = new CancelTravelCommand();
  //   command.setParameters(<ICancelTravelCommandParameters>{
  //     travelId: travelId,
  //     carrierUserId: carrierUserId,
  //     reasonForCancellation: motive,
  //     canceledBy: canceledBy,
  //     name: this._identityService.subUserName,
  //     userId: this._identityService.subUserId,
  //     checkPassengerCancelation: checkPassengerCancelation
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       this._notificationsService.showSuccessMessage(
  //         'toast.travels.cancel',
  //         'toast.travels.message.cancel_success'
  //       );
  //       return response;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.travels.cancel',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // getTravelDetail(
  //   travelId: number,
  //   carrierId: number
  // ): Observable<IGetTravelDetailResponse> {
  //   let command = new GetTravelDetailCommand();
  //   command.setParameters(<IGetTravelDetailCommandParameters>{
  //     travelId: travelId,
  //     carrierUserId: carrierId.toString(),
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .pipe(
  //       map(data => {
  //           return data
  //       }),
  //       catchError(() => {
  //         // this._notificationsService.showHttpErrorMessage(
  //         //   'toast.travels.detail',
  //         //   error
  //         // );
  //         return throwError(() => false);
  //       })
  //     )
  // }

  // getTravelDetailMin(id: number): Observable<IGetTravelForCandidateResponse> {
  //   let command = new GetTravelForCandidateCommand();
  //   command.setParameters(<IGetTravelForCandidateCommandParameters>{
  //     travelId: id,
  //     carrierUserId: this._identityService.userId,
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.travels.detail',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // getTravelSignature(
  //   travelId: number,
  //   carrierUserId: number
  // ): Observable<PassengerSignatureResponseDTO> {
  //   let command = new TravelSignatureCommand();
  //   command.setParameters(<ITravelSignatureCommandParameters>{
  //     travelId: travelId,
  //     carrierId: carrierUserId,
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .pipe(
  //       map(data => {
  //           return data as PassengerSignatureResponseDTO;
  //       }),
  //       catchError(() => {
  //         // if (error.status !== 404) {
  //         //   this._notificationsService.showHttpErrorMessage(
  //         //     'toast.travels.passenger_signature',
  //         //     error
  //         //   );
  //         // }
  //         return throwError(() => false);
  //       })
  //     )

  // }

  // checkCarrierAvailability(): Observable<ICheckCarrierAvailabilityResponse> {
  //   let command = new CheckCarrierAvailabilityCommand();
  //   command.setParameters(<ICheckCarrierAvailabilityParameters>{
  //     carrierUserId: this._identityService.userId,
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.carrier.check_availability',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // updateTravelDetailMin(
  //   travelDetailmin: TravelDetailMinRequest
  // ): Observable<IUpdateTravelMinResponse> {
  //   let command = new UpdateTravelMinCommand();
  //   command.setParameters(<IUpdateTravelMinCommandParameters>{
  //     carrierUserId: +this._identityService.userId,
  //     driverAssingId: travelDetailmin.driverAssingId,
  //     travelDate: travelDetailmin.travelDate,
  //     isProgrammed: travelDetailmin.isProgrammed,
  //     travelId: travelDetailmin.travelId,
  //   });

  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       this._notificationsService.showInfoMessage(
  //         'toast.travels.title',
  //         'toast.travels.message.update_travel'
  //       );
  //       return response;
  //     })
  //     .catch((error) => {
  //       if (error.error.errorCode === ErrorsEnum.TRAVEL_INVALID_STATE) {
  //         this._notificationsService.showInternalErrorMessage(
  //           'toast.shared.assign_error',
  //           'toast.travels.error_code.travel_invalid_state'
  //         );
  //       } else {
  //         this._notificationsService.showHttpErrorMessage(
  //           'toast.travels.detail',
  //           error
  //         );
  //       }
  //       return Observable.throw(error);
  //     });
  // }

  // getTotals(isProgrammed?: boolean, find?: string, dateFrom?: Date, dateTo?: Date, isPaxVip?: boolean  ): Observable<TotalsTravelsDTO> {
  //   let command = new GetTotalTravelsCommand();
  //   command.setParameters(<IGetTotalTravelsCommandParameters>{
  //     carrierUserId: +this._identityService.userId,
  //     isProgrammed: isProgrammed,
  //     find: find,
  //     dateFrom: dateFrom,
  //     dateTo: dateTo,
  //     isPaxVip
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.travels.title',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // public updateTravel(
  //   travelId: number,
  //   request: ITravelUpdate,
  //   userId: number
  // ): Observable<void> {
  //   let command = new PutTravelCommand();
  //   command.setUrlParameters(userId, travelId);
  //   command.addCommandBody(request);

  //   return this._connectionService
  //     .Request(command)
  //     .pipe(
  //       map(data => {

  //       }),
  //       catchError(() => {
  //         // this._notificationsService.showHttpErrorMessage(
  //         //   'toast.travel.detail',
  //         //   error.error.description
  //         // );
  //         return throwError(() => false);
  //       })
  //     )
  // }

  // getFilters(): TableFilter {
  //   return {
  //     urlPrefixes: ['state'],
  //     items: [
  //       {
  //         label: 'Activos',
  //         values: [
  //           `${TravelStateEnum.CLOSING_TRAVEL}-${TravelStateEnum.GOING_TO_CLIENT}-${TravelStateEnum.GOING_TO_DESTINATION}`,
  //         ],
  //       },
  //       {
  //         label: 'Perdidos',
  //         values: [`${TravelStateEnum.LOST}`],
  //       },
  //       {
  //         label: 'Finalizados',
  //         values: [`${TravelStateEnum.DONE}`],
  //       },
  //       {
  //         label: 'Programados',
  //         values: [
  //           `${TravelStateEnum.SCHEDULED}-${TravelStateEnum.SEARCHING_DRIVER}-${TravelStateEnum.WITH_DRIVER_ASSIGNED}`,
  //         ],
  //       },
  //       {
  //         label: 'A Asignar',
  //         values: [
  //           `${TravelStateEnum.SEARCHING_DRIVER}-${TravelStateEnum.WITH_DRIVER_ASSIGNED}-RESERVED`,
  //         ],
  //       },
  //       {
  //         label: 'Cancelados',
  //         values: [`${TravelStateEnum.CANCELLED}`],
  //       },
  //       {
  //         label: 'Conflicto',
  //         values: ['NO_AUTH-NO_PAY']
  //       }
  //     ],
  //   };
  // }
  // public cloneTravel(travelId: number): Observable<TravelsGridResponseDTO> {
  //   let travelCommand = new CloneTravelCommand();
  //   let request = <ICloneTravelCommandParameters>{};
  //   request.carrierUserId = +this._identityService.userId;
  //   request.travelId = travelId;
  //   travelCommand.setParameters(request);
  //   return this._connectionService
  //     .Request(travelCommand)
  //     .map((response) => {
  //       if (!response.autodispatch) {
  //         this.setTravelCreatedId(response.travelId);
  //         this._notificationsService.showSuccessMessage(
  //           'toast.travels.title',
  //           'toast.shared.message.successful_message_add'
  //         );
  //         if (response.limitExceeded == true) {
  //           this._notificationsService.showInternalErrorMessage(
  //             'toast.travels.error.title.trips',
  //             'toast.travels.error.message.checking_account_not_enough'
  //           );
  //         }
  //       }
  //       return response;
  //     })
  //     .catch((error) => {
  //       if (error.status === 404) {
  //         if (
  //           error.error.errorCode !== undefined &&
  //           error.error.errorCode !== null &&
  //           error.error.errorCode !== 'undefined'
  //         ) {
  //           if (error.error.errorCode === 'ACTION_NOT_ALLOWED') {
  //             this._notificationsService.showInternalErrorMessage(
  //               'toast.travels.title',
  //               'toast.travels.error_code.trips_action_not_allowed'
  //             );
  //           }
  //           if (error.error.errorCode === 'DRIVERS_NOT_AVAILABLE') {
  //             this._notificationsService.showInternalErrorMessage(
  //               'toast.travels.title',
  //               'toast.travels.error_code.drivers_not_available'
  //             );
  //             if (error.error.errorCode === 'TRAVEL_INVALID') {
  //               this._notificationsService.showInternalErrorMessage(
  //                 'toast.travels.title',
  //                 'toast.travels.error_code.travel_invalid'
  //               );
  //             }
  //             if (error.error.errorCode === 'PASSENGER_ALREADY_TRAVELING') {
  //               this._notificationsService.showInternalErrorMessage(
  //                 'toast.travels.title',
  //                 'toast.travels.error_code.passenger_already_travelling'
  //               );
  //             }
  //             this._navigationService.navigate(RouterEnum.travelGrid);
  //           }
  //         }
  //       } else if (error.status === 409) {
  //         if (error.error.errorCode === 'TRANSPORT_TYPE_NOT_FOUND') {
  //           this._notificationsService.showInternalErrorMessage(
  //             'toast.travels.title',
  //             'toast.travels.error_code.vehicle_type_unavailable'
  //           );
  //         }
  //       } else if (error.status === 406) {
  //         if (
  //           error.error.errorCode !== undefined ||
  //           error.error.errorCode !== null
  //         ) {
  //           if (error.error.errorCode === 'PASSENGER_ALREADY_TRAVELING') {
  //             this._notificationsService.showInternalErrorMessage(
  //               'toast.travels.title',
  //               'toast.travels.error_code.passenger_already_travelling'
  //             );
  //           }
  //           if (error.error.errorCode === 'TRAVEL_ALREADY_REACTIVATED') {
  //             this._notificationsService.showInternalErrorMessage(
  //               'toast.travels.title',
  //               'toast.travels.error_code.travel_already_reactivated'
  //             );
  //           }
  //         }
  //       } else if (error.status === 400) {
  //         if (
  //           error.error.errorCode !== undefined ||
  //           error.error.errorCode !== null
  //         ) {
  //           if (error.error.errorCode === 'INVALID_RECURRING_START') {
  //             this._notificationsService.showInternalErrorMessage(
  //               'toast.travels.title',
  //               'toast.travels.error_code.travel_invalid'
  //             );
  //           }
  //           if (error.error.errorCode === 'INVALID_RECURRING_END') {
  //             this._notificationsService.showInternalErrorMessage(
  //               'toast.travels.title',
  //               'toast.travels.error_code.invalid_recurring_end'
  //             );
  //           }
  //           if (error.error.errorCode === 'CONTRACTOR_AREA_INACTIVE') {
  //             this._notificationsService.showInternalErrorMessage(
  //               'toast.travels.title',
  //               'toast.contractor.error_code.contractor_area_inactive'
  //             );
  //           }
  //           if (error.error.errorCode === 'CONTRACTOR_EMPLOYEE_INACTIVE') {
  //             this._notificationsService.showInternalErrorMessage(
  //               'toast.travels.title',
  //               'toast.contractor.error_code.contractor_employee_inactive'
  //             );
  //           }
  //           if (error.error.errorCode === 'LIMIT_EXCEEDED') {
  //             this._notificationsService.showInternalErrorMessage(
  //               'Viajes',
  //               'No es posible reactivar el viaje. El saldo de la cta. cte. del cliente excede el limite acordado'
  //             );
  //           }
  //         } else {
  //           this._notificationsService.showHttpErrorMessage(
  //             'toast.travels.title',
  //             error
  //           );
  //         }
  //       } else {
  //         this._notificationsService.showHttpErrorMessage(
  //           'toast.travels.title',
  //           error
  //         );
  //       }
  //       return Observable.throw(false);
  //     });
  // }

  // getTravelAudit(
  //   travelId: number,
  //   carrierId: number
  // ): Observable<TravelAuditResponseDTO> {
  //   let command = new GetTravelAuditCommand();
  //   command.setParameters(<IGetTravelAuditCommandParameters>{
  //     travelId: travelId,
  //     carrierUserId: carrierId.toString(),
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .pipe(
  //       map(data => {
  //           return data as any;
  //       }),
  //       catchError(() => {
  //           // if (error.error.errorCode !== 'TRAVEL_NOT_FOUND') {
  //           //   this._notificationsService.showHttpErrorMessage(
  //           //     'toast.travels.audit',
  //           //     error
  //           //   );
  //           // }
  //           return throwError(() => false);
  //       })
  //   );
  // }

  // finalizeAdmin(
  //   travelId: number,
  //   userId: number,
  //   userManagerId: number,
  //   driverId: number
  // ): Observable<IUpdateTravelMinResponse> {
  //   let command = new FinalizeAdminTravelCommand();
  //   command.setParameters(<IFinalizeAdminTravelCommandParameters>{
  //     carrierUserId: +this._identityService.userId,
  //     travelId: travelId,
  //     userId: userId,
  //     userIdManager: userManagerId,
  //     driverId: driverId,
  //   });

  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       this._notificationsService.showInfoMessage(
  //         'toast.travels.title',
  //         'toast.travels.message.finalize_admin'
  //       );
  //       return response;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.travels.finalize_admin',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // putTravelFinalPrice(
  //   travelId: number,
  //   carrierId: number,
  //   reason: string,
  //   newPrice: number,
  //   userId: number,
  //   totalAmount: number,
  //   kmAmount: number,
  //   waitingMins: number,
  //   waitingPrice: number,
  //   otherCost: number,
  //   tollAmount: number,
  //   parkingAmount: number,
  // ): Observable<IPutTravelFinalPriceResponse> {
  //   let command = new PutTravelFinalPriceCommand();
  //   command.setUrlParameters({
  //     travelId: travelId,
  //     carrierUserId: carrierId.toString(),
  //   });
  //   command.addCommandBody({
  //     reason: reason,
  //     newTripAmount: newPrice,
  //     userId: userId,
  //     newTotalAmount: totalAmount,
  //     newKm: kmAmount,
  //     newWaitingMins: waitingMins,
  //     newWaitingPrice: waitingPrice,
  //     newOtherCost: otherCost,
  //     newToll: tollAmount,
  //     newParking: parkingAmount,
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .pipe(
  //       map(data => {
  //         return data as TravelSimulateResponseDto;
  //       }),
  //       catchError((error: any) => {
  //         return throwError(() => error);
  //     }));
  // }

  // patchChannelUserName(
  //   travelId: number,
  //   carrierUserId: string,
  //   channelUserId: string
  // ) {
  //   const command = new PutAuditUserNameCommand();
  //   command.setParameters(<IPutAuditUserNameCommandParameters>{
  //     travelId: travelId,
  //     carrierUserId: carrierUserId,
  //     channelUserId: channelUserId,
  //   });
  //   return this._connectionService.Request(command).catch((error) => {
  //     this._notificationsService.showHttpErrorMessage(
  //       'toast.shared.error_code.0',
  //       error
  //     );
  //     return Observable.throw(false);
  //   });
  // }
  // dispatchNow(
  //   travelId: number,
  //   carrierId: number,
  //   driverAvailable: boolean
  // ) {
  //   const command  = new TravelDispatchCommandParameters();
  //   command.setParameters(<IPutTravelDispatchParameters>{
  //       carrierUserId: carrierId,
  //       driverAvailable: driverAvailable,
  //       travelId: travelId
  //   });
  //   return this._connectionService
  //   .Request(command)
  //   .catch(error => {
  //     this._notificationsService.showHttpErrorMessage(
  //       'toast.shared.error_code.0',
  //       error
  //     );
  //     return Observable.throw(false);
  //   });
  // }

  getMagiisGeoCode(
    placeId?: string,
    coords?: { lat: number, lng: number },
    address?: string
  ): Observable<any[]> {
    const command = new MagiisGeoCodeServiceCommand();
    command.setParameters(<IMagiisGeoCodeServiceCommandParameters>{
      placeId: placeId,
      coords: coords,
      address: address
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map(data => {
          return data as any;
        }),
        catchError(() => {
          // this._notificationsService.showHttpErrorMessage(
          //   'toast.shared.error_code.0',
          //   error
          // );
          return throwError(() => false);
        }));
  }

  public getMaggisAutocomplete(
    request: IMagiisGetAutocompleteRequest
  ): Observable<IMagiisGetAutocompleteResponse[]> {
    const CarrierAreasSearchCommand = new GetMagiisAutocompleteCommand();
    CarrierAreasSearchCommand.setParameters(request);
    return this._connectionService
      .Request(CarrierAreasSearchCommand)
      .pipe(
        map(data => {
          return data as any;
        }),
        catchError((err) => {
          // this._notificationsService.showHttpErrorMessage(
          //   'toast.shared.error_code.0',
          //   error
          // );
          return throwError(() => err);
        }));
  }

  // TODO MX-5619: getCheckPlace — validates if a placeId is routable via backend
  getCheckPlace(placeId: string): Observable<ICheckPlaceResponse> {
    const command = new CheckPlaceCommand();
    command.setParameters(<ICheckPlaceParameters>{ placeId });
    return this._connectionService.Request(command).pipe(
      map((data: any) => data),
      catchError(() => throwError(() => ({ routable: true, reasons: [] })))
    );
  }

  public simulateAll(
    travelDTO: SimulateTravelRequestDTO
  ): Observable<TravelSimulateAllResponseDto> {
    let command = new SimulateAllTravelCommand();
    command.setParameters(<ISimulateTravelCommandParameters>{
      affiAgreementId: travelDTO.affiAgreementId,
      destination: travelDTO.destination,
      origin: travelDTO.origin,
      firstName: travelDTO.firstName,
      lastName: travelDTO.lastName,
      mail: travelDTO.mail,
      note: travelDTO.note,
      passengerUserId: travelDTO.passengerUserId,
      phoneNumber: travelDTO.phoneNumber,
      platform: travelDTO.platform,
      travelPreferences: travelDTO.travelPreferences,
      paymentMethod: travelDTO.paymentMethod,
      carrierUserId: travelDTO.carrierUserId,
      isDelivery: travelDTO.isDelivery,
      isRental: travelDTO.isRental,
      rentalType: travelDTO.rentalType,
      rentalHours: travelDTO.rentalHours,
      requesterUserId: travelDTO.requesterUserId,
      isProgrammed: travelDTO.isProgrammed,
      dateProgrammed: travelDTO.dateProgrammed,
      driverProgrammedId: travelDTO.driverProgrammedId,
      waypoints: travelDTO.waypoints,
      roundTrip: travelDTO.roundtrip,
      serviceType: travelDTO.serviceType,
      avoidTolls: travelDTO.avoidTolls || false,
      avoidHighways: travelDTO.avoidHighways || false,
      fastestRoute: travelDTO.fastestRoute || false,
      contractorEmployeeId: travelDTO.contractorEmployeeId,
      operatorUserId: travelDTO.operatorUserId,
      pbxCaller: travelDTO.pbxCaller,
      pickupGmt: travelDTO.pickupGmt,
      qrPayment: travelDTO.qrPayment,
      serviceTypeId: travelDTO.serviceTypeId,
      areaId: travelDTO.areaId,
      paxQty: travelDTO.paxQty
    });

    return this._connectionService
      .Request(command)
      .pipe(
        map(response => {
          return response as TravelSimulateAllResponseDto;
        }),
        catchError((error) => {
          //Agregar los errores por status!!
          return throwError(() => false);
        }));

    // return this._connectionService
    //   .Request(command)
    //   .map((response) => {
    //     return response as TravelSimulateAllResponseDto;
    //   })
    //   .catch((error) => {
    //     switch (error.status) {
    //       case 403:
    //         this._notificationsService.showInternalErrorMessage(
    //           'toast.travels.title',
    //           'toast.travels.error_code.requester_invalid'
    //         );
    //         break;
    //       case 406:
    //         this._notificationsService.showInternalErrorMessage(
    //           'toast.travels.title',
    //           'toast.travels.error_code.vehicle_inactive'
    //         );
    //         break;
    //       case 400:
    //         if (error.error.errorCode === 'CONTRACTOR_AREA_INACTIVE') {
    //           this._notificationsService.showInternalErrorMessage(
    //             'toast.travels.title',
    //             'toast.travels.error_code.contractor_area_inactive'
    //           );
    //           break;
    //         }
    //         if (error.error.errorCode === 'CONTRACTOR_EMPLOYEE_INACTIVE') {
    //           this._notificationsService.showInternalErrorMessage(
    //             'toast.travels.title',
    //             'toast.travels.error_code.contractor_employee_inactive'
    //           );
    //           break;
    //         }
    //         if (error.error.errorCode === 'RENTAL_CAR_NOT_CONFIGURED') {
    //           this._notificationsService.showInternalErrorMessage(
    //             'Viajes',
    //             'No están configuradas las opciones para la modalidad de viaje elegida.'
    //           );
    //           break;
    //         }
    //       case 409:
    //         if (error.error.errorCode === 'SERVICE_TYPE_OUT_OF_TIME') {
    //           this._notificationsService.showInternalErrorMessage(
    //             'toast.travels.title',
    //             'toast.travels.error_code.SERVICE_TYPE_OUT_OF_TIME'
    //           );
    //           break;
    //         }
    //         if (error.error.errorCode === 'USAGE_LIMIT_EXCEEDED') {
    //           this._notificationsService.showInternalErrorMessage(
    //             'toast.travels.title',
    //             'toast.travels.error_code.USAGE_LIMIT_EXCEEDED'
    //           );
    //           break;
    //         }
    //       default:
    //         this._notificationsService.showHttpErrorMessage(
    //           'toast.travels.title',
    //           error
    //         );
    //         return Observable.throw(false);
    //     }
    //   });
  }

}

export interface ITravelCandidate {
  travelId: number;
  numberOfCandidates: number;
}

